import { allPropellerMetricNames } from '@shared_types/metrics/propeller_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_PROPELLERS, UPDATE_PROPELLERS } from '../actions'

const initialState = initializeMetrics(allPropellerMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_PROPELLERS || type === UPDATE_PROPELLERS) {
    console.log('init propellers', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
